import React, { useState } from "react";
import { motion } from "framer-motion";

const Servicess = () => {
  const services = [
    { name: "Piles", icon: "💉" },
    { name: "Anal Fistula", icon: "🩺" },
    { name: "Anal Fissure", icon: "🧪" },
    { name: "Gallstone", icon: "🫧" },
    { name: "Kidney Stones", icon: "💧" },
    { name: "Cataract", icon: "👁️" },
    { name: "Lasik Eye Surgery", icon: "🔍" },
    { name: "Hernia", icon: "⚕️" },
    { name: "Appendicitis", icon: "💊" },
    { name: "Varicose Veins", icon: "🩸" },
    { name: "Thyroid Surgery", icon: "🧬" },
    { name: "Liposuction", icon: "⚡" },
    { name: "Piles", icon: "💉" },
    { name: "Anal Fistula", icon: "🩺" },
    { name: "Anal Fissure", icon: "🧪" },
    { name: "Gallstone", icon: "🫧" },
    { name: "Kidney Stones", icon: "💧" },
    { name: "Cataract", icon: "👁️" },
    { name: "Lasik Eye Surgery", icon: "🔍" },
    { name: "Hernia", icon: "⚕️" },
    { name: "Appendicitis", icon: "💊" },
    { name: "Varicose Veins", icon: "🩸" },
    { name: "Thyroid Surgery", icon: "🧬" },
    { name: "Liposuction", icon: "⚡" },
  ];

  const [showAll, setShowAll] = useState(false);
  const visibleServices = showAll ? services : services.slice(0, 12);

  return (
    <section
      style={{
        padding: "100px 0",
        background: "radial-gradient(circle at 50% 20%, #e7f2ff 0%, #ffffff 70%)",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* Background Overlay */}
      <div
        style={{
          position: "absolute",
          top: "-80px",
          left: "0",
          width: "100%",
          height: "300px",
          opacity: "0.2",
        }}
      ></div>

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2
            style={{
              fontSize: "42px",
              fontWeight: "800",
              color: "#0b1c39",
              marginBottom: "15px",
              letterSpacing: "1px",
            }}
          >
            Discover <span style={{ color: "#ffcb24" }}>Best Treatments</span>
          </h2>
          <p
            style={{
              fontSize: "18px",
              color: "#555",
              maxWidth: "600px",
              margin: "0 auto",
              lineHeight: "1.8",
            }}
          >
            Book your appointment online with top specialists and start your
            journey towards better health.
          </p>
        </div>

        {/* Services Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "25px",
            maxWidth: "1100px",
            margin: "0 auto",
          }}
        >
          {visibleServices.map((service, index) => (
            <motion.div
              key={index}
              whileHover={{
                scale: 1.05,
                y: -5,
                boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
              }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#ffffff",
                borderRadius: "20px",
                padding: "25px 15px",
                textAlign: "center",
                boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
                border: "1px solid rgba(9,187,175,0.15)",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            >
              <div
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  background: "#ffcb24",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "2rem",
                  margin: "0 auto 15px",
                  color: "#0b1c39",
                }}
              >
                {service.icon}
              </div>
              <p
                style={{
                  fontSize: "17px",
                  fontWeight: "600",
                  color: "#0b1c39",
                  margin: 0,
                  lineHeight: "1.6",
                }}
              >
                {service.name}
              </p>
            </motion.div>
          ))}
        </div>

        {/* View More Button */}
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => setShowAll((prev) => !prev)}
            style={{
              background: "#09bbaf",
              color: "#ffffff",
              border: "none",
              padding: "16px 40px",
              borderRadius: "12px",
              fontSize: "17px",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
            }}
          >
            {showAll ? "Show Less" : "View More Treatments ▼"}
          </motion.button>
        </div>

        {/* Info Box */}
        <div
          style={{
            background: "#09bbaf",
            color: "#fff",
            padding: "30px",
            borderRadius: "20px",
            textAlign: "center",
            marginTop: "60px",
            boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
          }}
        >
          <h4
            style={{
              fontSize: "22px",
              fontWeight: "600",
              marginBottom: "15px",
            }}
          >
            🏥 Comprehensive Healthcare Solutions
          </h4>
          <p
            style={{
              color: "rgba(255,255,255,0.9)",
              fontSize: "17px",
              margin: 0,
              maxWidth: "800px",
              marginLeft: "auto",
              marginRight: "auto",
              lineHeight: "1.8",
            }}
          >
            From minor procedures to complex surgeries, we offer a wide range of
            medical treatments performed by experienced specialists using
            advanced technology and compassionate care.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Servicess;
